<template>
    <div>
        <warranty-table v-if="!is_loading && warranties.length > 0" :sync-pos-items="syncPosItems" :warranties="warranties" :user="user" :url="getPurchaserSenhengUrl"></warranty-table>
        <div class="container">
            <div class="row" v-if="!is_loading && warranties.length == 0">
                <div class="col s12">
                    <div class="card-panel center-align">
                        No warranty registered yet. <a v-bind:href="registerWarrantyUrl">Create Now</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col s12 center-align" v-if="is_loading">
                <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true" style="font-size: 2.5rem;"></i>
            </div>
        </div>
    </div>
</template>

<script>
    import WarrantyTableComponent from '../partials/WarrantyTableComponent';

    export default {
        name: "ViewComponent",
        props: [
            'siteUrl',
            'userId',
            'getWarrantyListUrl',
            'getUserUrl',
            'getPrintInvoiceUrl',
            'registerWarrantyUrl',
            'getPurchaserSenhengUrl',
            'syncPosItems'
        ],
        components: {
            'warranty-table': WarrantyTableComponent
        },
        data() {
            return {
                user: '',
                warranties: [],
                is_loading: true,
            }
        },
        mounted () {
            this.getUserByIcNumber();
            this.getWarrantyListByUserId();
            console.log(this.userId);
        },
        methods: {
            getWarrantyListByUserId () {
                let me = this;
                axios.get(this.getWarrantyListUrl, {
                    params: {
                        user_id: this.userId
                    }
                }).then(function (response) {
                    me.warranties = response.data.warranties;
                    me.is_loading = false;
                })
                    .catch(function (error){
                    });
            },
            getUserByIcNumber () {
                let me = this;
                axios.get(this.getUserUrl, {
                    params: {
                        id: this.userId
                    }
                    }).then(function (response) {
                        me.user = response.data.user;

                    })
                    .catch(function (error){
                    });
            },
            promptPrint ()
            {

            }
        }
    }
</script>

<style scoped>

</style>
